import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoSetting } from '../interfaces/dto.setting.interface';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';

// @dynamic
@JsonObject('DtoSetting')
export class DtoSetting extends ModelEntity implements IDtoSetting {

    constructor(initValues: Partial<IDtoSetting> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('paramType', String, true)
    public paramType?: string = null;

    @JsonProperty('paramKey', String, true)
    public paramKey?: string = null;

    @JsonProperty('paramValue', String, true)
    public paramValue?: string = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

}
